// Narrow corrections to existing uniform colour translations. These are
// installed after the common namespace loads, following the established
// supplemental translation pattern. Do not change uniform IDs or colour data.
export const uniformColourTranslationCorrections = Object.freeze({
  ur: Object.freeze({
    'uniforms.grey.description': 'گہرے نیلے رنگ کی پٹی کے ساتھ گرے',
  }),
});

export function installUniformColourTranslationCorrections(i18n, language) {
  const code = String(language || '').toLowerCase().split('-')[0];
  const corrections = uniformColourTranslationCorrections[code];
  if (!corrections) return;
  for (const [key, value] of Object.entries(corrections)) {
    i18n.addResource(language, 'common', key, value);
  }
}
